

const MieszkaniecWydrukDokument = () => {


    return (
        <section
            style={{
                fontSize: "10px",
                padding: "15px 0",
                position: "absolute", 
                left: "50px",
                bottom: "5px"
            }}
        >
            <p
                style={{
                    textAlign: 'left'
                }}
            >
                {`Dokument wygenerowany elektronicznie z systemu BON Administrator. Nie wymaga podpisu.`}
            </p>
        </section>
    )
}

export default MieszkaniecWydrukDokument;